import script from "./DrawingMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawingMenu.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__